











import { Vue, Component } from 'vue-property-decorator';
import LaborantMenu from '@/components/spec/LaborantMenu.vue';
import TopPanel from '@/components/dummy/TopPanel.vue';
import Header from '@/components/dummy/Header.vue';
import Footer from '@/components/dummy/Footer.vue';
//import app from "@/store/modules/app";

@Component({
  components: { Footer, Header, TopPanel, LaborantMenu },
})
export default class Laborant extends Vue {
  onResize() {
    //console.log("InnerWidth:", window.innerWidth);
    //app.isMobile = window.innerWidth < 600;
  }

  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  get getInner() {
    return window.innerWidth;
  }

  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize);
    }
  }
}
